// windowDataLoader.js
import json11 from "../../../assets/base_models/windowData.json"
export async function loadWindowData() {
    // const response = await fetch("/assets/base_models/windowData.json"); // Fetch JSON data from the file
    // const data = await response.json();
    return json11;
}
